import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { UpdateLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/location/update-location.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { LocationUpdateFormStep1Controller } from '@app/feature/location/location-update/location-update-form-step-1/location-update-form-step-1.controller';
import { LocationUpdateFormStep2Controller } from '@app/feature/location/location-update/location-update-form-step-2/location-update-form-step-2.controller';
import { useUpdateLocationContext } from '@app/feature/location/location.context';

interface LocationUpdateFormControllerProps {
  onError: SubmitErrorHandler<
    Pick<UpdateLocationModel, 'locationId' | 'location'>
  >;
  onSubmit: SubmitHandlerWithDirtyFields<
    Pick<UpdateLocationModel, 'locationId' | 'location'>
  >;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const LocationUpdateFormController = (
  props: LocationUpdateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const { t } = useTranslation();
  const data = useUpdateLocationContext();

  return (
    <MultiStepFormProvider<Pick<UpdateLocationModel, 'locationId' | 'location'>>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          title: t('$.location-update.step-1.title'),
          iconName: 'location',
          fields: [
            'location.name',
            'location.type',
            'location.facilities',
            'location.openingTimes',
          ],
          component: <LocationUpdateFormStep1Controller />,
        },
        {
          title: t('$.location-update.step-2.title'),
          iconName: 'marker-pin-04',
          fields: [
            'location.address',
            'location.city',
            'location.postalCode',
            'location.country',
            'location.coordinates.latitude',
            'location.coordinates.longitude',
          ],
          component: <LocationUpdateFormStep2Controller />,
        },
      ]}
    />
  );
};
